import React from 'react'

const EmbeddedContent: React.FC<{ id: string, testId: string }> = ({ id, testId }) => {
  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
      }}
      id={id}
      data-testid={testId}
      data-cy={testId}
    />
  )
}

export default EmbeddedContent
